import { useEffect, useRef } from "react"
import io from "socket.io-client"
import { useStore } from "../store"
// import { usePOIStore } from "./activePOIStore"

const CameraPosBroadcaster = () => {
  const socket = useRef()
  const url = process.env.REACT_APP_MARKETING_SUITE
  const role = process.env.REACT_APP_ROLE

  const currentCameraPositionID = useStore(state => state.currentCameraPositionID)
  const setCurrentCameraPositionID = useStore(state => state.setCurrentCameraPositionID)

  const state = { currentCameraPositionID: currentCameraPositionID }

  useEffect(() => {
    socket.current = io(url)
    socket.current.emit("subscribe-camzustand", 1000)
    if (role === "recipient") {
      socket.current.on("camzustand", zustand => {
        setCurrentCameraPositionID(zustand.currentCameraPositionID)
      })
    }
    return () => socket.current.close()
  }, [state, role, url])

  useEffect(() => {
    if (role === "sender") {
      socket.current.emit("camzustand", state)
    }
  }, [state, role, url])

  return null
}

CameraPosBroadcaster.propTypes = {}

export default CameraPosBroadcaster
